import { render, staticRenderFns } from "./setmealList.vue?vue&type=template&id=1037ffc3&"
import script from "./setmealList.vue?vue&type=script&lang=js&"
export * from "./setmealList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports